import { Card, CardActions, CardContent, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSignIn } from "../../auth";
import SubmitButton from "../../components/SubmitButton";

export default function Demo() {
  const { t } = useTranslation("welcome");
  const [pending, setPending] = useState(false);
  const signIn = useSignIn();
  const doSignIn = useCallback(() => {
    setPending(true);
    signIn("demo");
  }, [signIn]);

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <CardContent>
        <Typography variant="h5" gutterBottom>
          {t("demo.title")}
        </Typography>
        <Typography gutterBottom>{t("demo.info")}</Typography>
      </CardContent>
      <CardActions>
        <SubmitButton fullWidth onClick={doSignIn} loading={pending}>
          {t("demo.action")}
        </SubmitButton>
      </CardActions>
    </Card>
  );
}
